import React  from 'react';
import styled, { css } from 'styled-components';
import __ from '../utils/translator';
import Link from '../icons/Link';
import StoryCompletedIcon from './story-completion/StoryCompletedIcon';
import Container from './story-completion/Container';
import BackgroundImage from './story-completion/BackgroundImage';
import ContainerInner from './story-completion/ContainerInner';
import Title from './story-completion/Title';
import ThemeContainer from './story-completion/ThemeContainer';
import LinkButton from './LinkButton';
import RelatedThemeCard from './RelatedThemeCard';
import NextThemeCard from './NextThemeCard';
import thronThumbnailResize from '../utils/thronThumbnailResize';

function hasRelated(related) {
  return related.length > 0;
}

export default ({ related = [], theme, nextTheme = null, exploreLink, exploreCallToAction, ...props }) => (
  <React.Fragment>
    <Container>
      <BackgroundImage
        src={thronThumbnailResize(theme.cover, { width: 20 })}
        hasRelated={hasRelated(related)} />

      <ContainerInner hasRelated={hasRelated(related)}>
        <StoryCompletedIcon />

        {nextTheme ? (
          <Title>{__("That’s great, keep up and move to the next one!")}</Title>
        ) : (
          <Title>{__("That’s great!")}</Title>
        )}

        {nextTheme !== null && (
          <ThemeContainer>
            <NextThemeCard theme={nextTheme} />
          </ThemeContainer>
        )}

        <LinkButton
          style={{ marginTop: '2rem', }}
          onClick={() => window.scrollTo(0, 0)}
          color="secondary"
          size="large"
          to={exploreLink}>
          {exploreCallToAction}
        </LinkButton>

        {hasRelated(related) && (
          <RelatedThemeTitle>
            <LinkIcon />
            {__('Related content')}
          </RelatedThemeTitle>
        )}
      </ContainerInner>
    </Container>

    {hasRelated(related) && (
      <RelatedThemeContainer scrollable={related.length > 4}>
        {related.map(theme => (
          <RelatedThemeCard key={theme.id} theme={theme} />
        ))}

        {/*
         * Add some right padding to make it easier to see that the are no more
         * themes to the right.
         */}
        {related.length > 4 && (
          <div style={{ flex: '0 0 3rem', }}/>
        )}
      </RelatedThemeContainer>
    )}
  </React.Fragment>
);

const LinkIcon = styled(Link)`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin-right: .25rem;
`;

const RelatedThemeContainer = styled.div`
  z-index: 2;
  position: relative;
  display: flex;
  justify-content: center;
  height: 10rem;
  margin-top: -2.5rem;
  margin-bottom: 4.5rem;
  
  ${({ scrollable }) => scrollable && css`
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  `};
`;

const RelatedThemeTitle = styled.h3`
  position: relative;
  margin-top: 2rem;
  margin-bottom: .1875rem;
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  
  &:after {
    content: "";
    position: absolute;
    bottom: -.1875rem;
    left: 50%;
    display: block;
    width: 3.5rem;
    height: .1875rem;
    margin-left: -1.75rem;
    background-color: #fff;
  }
`;
